module.exports = __webpack_public_path__ + "static/img/Tech_06.f79a7163.png";